import {
  ComboBox,
  DefaultButton,
  IComboBox,
  IComboBoxOption,
  Panel,
  PanelType,
  PrimaryButton,
} from "@fluentui/react";
import React, { useCallback, useState, useEffect } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { useComboEquipoTrabajoRol } from "../../../hooks/combosHooks/useComboEquipoTrabajoRol";
import { IOpenPanel } from "../../../Interfaces/IPanel";
import { IPanel } from "../../auxiliar/configuraciones/razonModelo/razonModeloNuevo/PanelNuevoRazonModelo";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { Ifilter } from "../../../Interfaces/filter";
import { useTableSupervisores } from "../../../hooks/TablasHooks/useTableSupervisores";
import { get } from "http";

interface IPanelFilterSupervisore {
  isOpen: boolean;
  onDismiss: () => void;
  limpiarFiltro: () => void;
  setter: React.Dispatch<React.SetStateAction<Ifilter & {equipoTrabajoRolId?: string}>>;
  getter: Ifilter & {equipoTrabajoRolId?: string};
}

export const PanelFilterSupervisore = (props: IPanelFilterSupervisore) => {
  
  const [localFilter, setLocalFilter] = useState<Ifilter & {equipoTrabajoRolId?: string}>(props.getter);

  useEffect(() => {
    if (props.isOpen) {
      setLocalFilter(props.getter);
    }
  }, [props.isOpen, props.getter]);

  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            justifyItems: "center",
            height: "5%",
            padding: "20px",
            margin: "20px",
          }}
        >
          <div style={{ display: "flex" }}>
            <PrimaryButton
              onClick={() => {
                limpiarFiltro();
              }}
              text={"Limpiar Filtro"}
            />
          </div>
          <div style={{ display: "flex" }}>
            <DefaultButton
              onClick={() => {
                props.onDismiss();
              }}
              text={"Cancelar"}
            />
          </div>
        </div>
      </>
    ),
    [props.onDismiss, props.limpiarFiltro]
  );
  const onRenderHeaderPanel = useCallback(
    () => (
      <>
        <PanelHeader
          key={"agregar"}
          nameIconHeader="filter"
          subTextHeader="Filtrar Tabla de Supervisores "
          textHeader="Filtro Avanzado Supervisores"
        />
      </>
    ),
    []
  );

  const _onChangeEquipoTrabajoRol = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event != undefined && option != undefined) {
      setLocalFilter({
        ...localFilter,
        equipoTrabajoRolId: option.key.toString(),
      });
    }
  };

  const limpiarFiltro = () => {
    props.setter({
      search: "",
      skip: 0,
      take: 50,
      equipoTrabajoRolId: undefined
    });
  };

  const {
    dataComboEquipoTrabajoRol,
    onClickComboEquipoTrabajoRol,
    _onkeyUpSearchEquipoTrabajoRol,
    comboBoxRefEquipoTrabajoRol,
    limpiarFilters,
  } = useComboEquipoTrabajoRol();


  const filtrar = () => {
    props.setter(localFilter);
    props.onDismiss();
  };

  return (
    <>
      <PanelGenerico
        onRenderHeader={onRenderHeaderPanel}
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        cancelar={limpiarFiltro}
        registrar={filtrar}
        textRegister="Buscar"
        textCancel="Limpiar"
        enabledHeader
        objectRenderBodyHelp={props.getter}
      >
        {/* Contenido del Panel */}
        <div className="ms-Grid-col ms-sm12 ms-lg12">
          <ComboBox
            useComboBoxAsMenuWidth
            allowFreeform
            autoComplete="off"
            onKeyUp={_onkeyUpSearchEquipoTrabajoRol}
            label="Rol Equipo de Trabajo"
            options={dataComboEquipoTrabajoRol.filter((it) => it.descripcion == "5" || it.descripcion == "3" )}
            componentRef={comboBoxRefEquipoTrabajoRol}
            onChange={_onChangeEquipoTrabajoRol}
            onClick={onClickComboEquipoTrabajoRol}
            selectedKey={localFilter.equipoTrabajoRolId ?? ""}
            styles={{ optionsContainer: { maxHeight: 200 } }}
          />
          </div>
      </PanelGenerico>
    </>
  );
};
